import {library} from "@fortawesome/fontawesome-svg-core";

import * as fasIcons from "./fas";

library.add(...Object.values(fasIcons));
